import {AppBar, Button, Toolbar} from '@mui/material';
import styled from 'styled-components';
import seedflexLogo from '@assets/icons/seedflex-header.svg';
import jaideeLogo from '@assets/icons/JaideeLogo.svg';
import {dispatch} from '@store';
import {loginActions} from '@pages/Login/auth/store/loginReducer';
import {newLimitActions} from '@pages/NewLimitOverride/newLimitOverrideReducer';
import {getCountryCodeFromUrl, getTheme} from '@shared/api/api';

const StyledAppBar = styled(AppBar)`
  && {
    background-color: #fafafa;
    box-shadow: none;
    border-bottom: 1px solid #d9d9d9;
    button {
      width: 100px;
      background-color: #4650ef;
      color: #ffffff;
    }
    .MuiToolbar-root {
      justify-content: space-between;
    }
  }
`;

function Header() {
  const themeName = getTheme();
  const onLogout = () => {
    dispatch(loginActions.logout());
    dispatch(newLimitActions.resetState());
  };
  const countryCode = getCountryCodeFromUrl();
  if (themeName === 'lender') return null;
  return (
    <StyledAppBar position='static'>
      <Toolbar>
        <img
          src={countryCode === 'TH' ? jaideeLogo : seedflexLogo}
          alt='Logo'
          style={{width: countryCode === 'TH' ? '140px' : 'auto'}}
        />
        <Button onClick={onLogout}>Logout</Button>
      </Toolbar>
    </StyledAppBar>
  );
}

export default Header;
